import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import StringField from './StringField';
import BooleanField from './BooleanField';
import SelectField from './SelectField';

import { IBand } from './dataEdit/Interfaces';

require('../../../_common/platform/sass/grid-band-field.sass');

const asTreeFlag = true; //LL: my flag

export function isBandName(name: string) {
    let k = name == null ? -1 : name.indexOf(bandPrefix);

    return k === 0;
}

export function bandsHaveCyclicRefs(bands: IBand[]) {
    if (bands == null || bands.length === 0) {
        return false;
    }

    let cycled = '';

    _.each(bands, (band) => {
        let name = band.name;
        let cycle = false;
        let seen = [];
        let b = band;

        while (b.band != null) {
            if (b.band === name) {
                cycle = true;
                break;
            }

            let n = _.indexOf(seen, b.band);

            if (n >= 0) {
                cycle = true;
                break;
            }
            seen.push(b.band);

            b = getBand(bands, b.band);
        }

        if (cycle) {
            cycled += name + ' ';
        }
    });

    //LL: or return cycled list
    return cycled.length > 0;
}

function getBand(bands: IBand[], bandName: string) {
    return _.find(bands, (band) => {
        return band.name === bandName;
    });
}

//LL: when as Tree
function calculateLevel(bands: IBand[], band: IBand) {
    if (band == null || band.name == null) {
        return 0;
    }

    if (bands == null) {
        return 0;
    }

    //LL: cycles are validated
    let level = 0;
    let b = band;

    while (b != null && b.band != null) {
        level++;
        b = getBand(bands, b.band);
    }

    return level;
}

//LL: 26.05.21: when AsTreeFlag
function GridBandFieldTreeRow(props: {
    value?;
    bands?: IBand[];
    i?: number;

    onChange(value, i: number): void;
    onRemove?(i: number): void;
    onAddChild?(i: number): void;
}) {
    const normalize = (value) => {
        if (value.name == null) {
            delete value.caption;
            delete value.hidden;
            delete value.allowColChooser;
            delete value.fixed;

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}
    };

    const handleOnValueChange = (value) => {
        normalize(value);

        if (typeof props.onChange === 'function') {
            props.onChange(value, props.i);
        }
    };

    const handleOnRemove = () => {
        if (typeof props.onRemove === 'function') {
            props.onRemove(props.i);
        }
    };

    const getRemoveButton = (value) => {
        if (value.name == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={handleOnRemove}></span>;
    };

    const handleOnAddChild = () => {
        if (typeof props.onAddChild === 'function') {
            props.onAddChild(props.i);
        }
    };

    const getAddChildButton = (value) => {
        if (value.name == null) {
            return;
        }

        return <span className="glyphicon glyphicon-plus" onClick={handleOnAddChild} title="Add sub-Band"></span>;
    };

    //LL: now readonly
    const handleOnNameChange = (val) => {
        let obj = _.clone(props.value || {});

        obj.name = val;
        handleOnValueChange(obj);
    };

    const handleOnNameClick = (e) => {
        let obj = _.clone(props.value || {});

        obj.name = '';
        handleOnValueChange(obj);
    };

    const getName = (value) => {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={handleOnNameClick}>
                    {'Add Band'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        const level = calculateLevel(props.bands, value);
        const style1 = { paddingLeft: 16 * level + 'px' };

        //LL:  readOnly field, "name" is generated in addRow
        return (
            <div style={style1}>
                <StringField
                    value={displayVal}
                    readOnly={true}
                    allowNull={false}
                    applyOnEnter={true}
                    changeOnBlurOnly={true}
                    onChange={handleOnNameChange}
                />
            </div>
        );
    };

    const handleOnCaptionChange = (val) => {
        let obj = _.clone(props.value || {});

        obj.caption = val;
        handleOnValueChange(obj);
    };

    const getCaptionTitle = (value) => {
        return value.caption || '';
    };

    const getCaption = (value) => {
        if (value.name == null) {
            return;
        }

        return (
            <StringField
                value={value.caption || ''}
                placeholder={value.name}
                readOnly={false}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
                onChange={handleOnCaptionChange}
            />
        );
    };

    const handleOnHiddenChange = (val) => {
        let obj = _.clone(props.value || {});

        obj.hidden = val;
        handleOnValueChange(obj);
    };

    const getHidden = (value) => {
        if (value.name == null) {
            return;
        }

        let hidden = value.hidden;

        return (
            <div className="nowrap">
                <div className="inline-block">
                    <BooleanField title={''} value={hidden} allowNull={false} onChange={handleOnHiddenChange} />
                </div>
            </div>
        );
    };

    //LL: don't use now. But don't remove
    //processAllowColChooserChange = (val) => {
    //    let obj = _.clone(props.value || {});
    //    obj.allowColChooser = val;
    //    handleValueChange(obj);
    //};
    //getAllowInColChooser(value) {
    //    if (value.name == null) {
    //        return;
    //    }
    //
    //    let allowColChooser: any = value.allowColChooser;
    //    return (
    //        <div className="nowrap">
    //            <div className="inline-block">
    //                <BooleanField
    //                    title={''}
    //                    value={allowColChooser}
    //                    allowNull={false}
    //                    onChange={processAllowColChooserChange}
    //                />
    //            </div>
    //        </div>
    //    );
    //}

    const handleOnFixedChange = (val) => {
        let obj = _.clone(props.value || {});

        if (val === 'none') {
            delete obj.fixed;
        } else {
            obj.fixed = val;
        }

        handleOnValueChange(obj);
    };

    const getFixed = (value) => {
        if (value.name == null) {
            return;
        }

        const options = _.map(['none', 'left', 'right'], (opt, i) => {
            return (
                <option key={opt + '-' + i} value={opt}>
                    {opt}
                </option>
            );
        });

        const fixed = value.fixed || 'none';

        return (
            <SelectField value={fixed} onChange={handleOnFixedChange}>
                {options}
            </SelectField>
        );
    };

    const value = props.value || {};

    // <td className="cell-allowColChooser">{getAllowInColChooser(value)}</td>
    return (
        <tr>
            <td className="cell-remove">{getAddChildButton(value)}</td>
            <td className="cell-remove">{getRemoveButton(value)}</td>
            <td className="cell-name">{getName(value)}</td>
            <td className="cell-caption" title={getCaptionTitle(value)}>
                {getCaption(value)}
            </td>
            <td className="cell-fixed">{getFixed(value)}</td>
            <td className="cell-hidden">{getHidden(value)}</td>
        </tr>
    );
}

function GridBandFieldRow(props: {
    value?;
    bands?: IBand[];
    i?: number;

    onChange(value, i: number): void;
    onRemove?(i: number): void;
}) {
    const normalize = (value) => {
        if (value.name == null) {
            delete value.caption;
            delete value.hidden;
            delete value.allowColChooser;
            delete value.fixed;
            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}
    };

    const handleOnValueChange = (value) => {
        normalize(value);

        if (typeof props.onChange === 'function') {
            props.onChange(value, props.i);
        }
    };

    const handleOnRemove = () => {
        if (typeof props.onRemove === 'function') {
            props.onRemove(props.i);
        }
    };

    const getRemoveButton = (value) => {
        if (value.name == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={handleOnRemove}></span>;
    };

    //LL: now readonly
    const handleOnNameChange = (val) => {
        let obj = _.clone(props.value || {});

        obj.name = val;
        handleOnValueChange(obj);
    };

    const handleOnNameClick = (e) => {
        let obj = _.clone(props.value || {});

        obj.name = '';
        handleOnValueChange(obj);
    };

    const getName = (value) => {
        if (value.name == null) {
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">
                            <button type="button" className="btn btn-default btn-sm" onClick={handleOnNameClick}>
                                {"Add Band (Try. Please, don't save with Bands)"}
                            </button>
                        </span>
                    </div>
                </div>
            );
        }

        //LL:  readOnly field, "name" is generated in addRow
        return (
            <StringField
                value={value.name || ''}
                readOnly={true}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
                onChange={handleOnNameChange}
            />
        );
    };

    const handleOnCaptionChange = (val) => {
        let obj = _.clone(props.value || {});
        obj.caption = val;
        handleOnValueChange(obj);
    };

    const getCaptionTitle = (value) => {
        return value.caption || '';
    };

    const getCaption = (value) => {
        if (value.name == null) {
            return;
        }

        let displayVal = value.caption || '';
        return (
            <StringField
                onChange={handleOnCaptionChange}
                value={displayVal}
                placeholder={value.name}
                readOnly={false}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    };

    const handleOnHiddenChange = (val) => {
        let obj = _.clone(props.value || {});

        obj.hidden = val;
        handleOnValueChange(obj);
    };

    const getHidden = (value) => {
        if (value.name == null) {
            return;
        }

        let hidden = value.hidden;

        return (
            <div className="nowrap">
                <div className="inline-block">
                    <BooleanField title={''} value={hidden} allowNull={false} onChange={handleOnHiddenChange} />
                </div>
            </div>
        );
    };

    const handleOnAllowColChooserChange = (val) => {
        let obj = _.clone(props.value || {});

        obj.allowColChooser = val;
        handleOnValueChange(obj);
    };

    const getAllowInColChooser = (value) => {
        if (value.name == null) {
            return;
        }

        let allowColChooser = value.allowColChooser;

        return (
            <div className="nowrap">
                <div className="inline-block">
                    <BooleanField
                        title={''}
                        value={allowColChooser}
                        allowNull={false}
                        onChange={handleOnAllowColChooserChange}
                    />
                </div>
            </div>
        );
    };

    const handleOnFixedChange = (val) => {
        let obj = _.clone(props.value || {});

        if (val === 'none') {
            delete obj.fixed;
        } else {
            obj.fixed = val;
        }

        handleOnValueChange(obj);
    };

    const getFixed = (value) => {
        if (value.name == null) {
            return;
        }

        const options = _.map(['none', 'left', 'right'], (opt, i) => {
            return (
                <option key={opt + '-' + i} value={opt}>
                    {opt}
                </option>
            );
        });

        const fixed = value.fixed || 'none';

        return (
            <SelectField value={fixed} onChange={handleOnFixedChange}>
                {options}
            </SelectField>
        );
    };

    const processBandChange = (val) => {
        let obj = _.clone(props.value || {});

        if (val === 'none') {
            delete obj.band;
        } else {
            obj.band = val;
        }
        handleOnValueChange(obj);
    };

    const getBand = (value) => {
        if (value.name == null) {
            return;
        }

        let bands = props.bands || [];

        //LL: cyclic refs ?

        const options = _.map(bands, (band, i) => {
            if (value.name === band.name) {
                return null;
            } else {
                return (
                    <option key={band.name + '-' + i} value={band.name}>
                        {band.name}
                    </option>
                );
            }
        });

        const displayVal = value.band || 'none';

        return (
            <SelectField value={displayVal} onChange={processBandChange}>
                <option key="none" value="none">
                    {'none'}
                </option>
                {options}
            </SelectField>
        );
    };

    let value = props.value || {};

    return (
        <tr>
            <td className="cell-band">{getBand(value)}</td>
            <td className="cell-remove">{getRemoveButton(value)}</td>
            <td className="cell-name">{getName(value)}</td>
            <td className="cell-caption" title={getCaptionTitle(value)}>
                {getCaption(value)}
            </td>
            <td className="cell-fixed">{getFixed(value)}</td>
            <td className="cell-hidden">{getHidden(value)}</td>
            <td className="cell-allowColChooser">{getAllowInColChooser(value)}</td>
        </tr>
    );
}

const bandPrefix = 'Band_';

export default function GridBandField(props: {
    value: IBand[];
    border?: boolean;

    onChange(value: IBand[]): void;
}) {
    const [contentShown, setContentShown] = React.useState(false);

    const handleValueChange = (value) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const getMaxNameIndex = (arr: IBand[]) => {
        let K = 0;

        _.each(arr, (band) => {
            let name = band.name || bandPrefix + 0;
            let s = name.substring(bandPrefix.length);

            if (s != null && !isNaN(s as any)) {
                let n = parseInt(s, 10);

                if (!isNaN(n) && n > K) {
                    K = n;
                }
            }
        });

        return K;
    };

    const handleOnAddRow = (obj) => {
        let arr = props.value.slice(0);
        let K = getMaxNameIndex(arr) + 1;

        obj.name = bandPrefix + K;
        obj.hidden = false;
        obj.allowColChooser = true;
        //obj.fixed = null;

        arr.push(obj);
        handleValueChange(arr);
    };

    //LL: when Tree
    const handleOnAddChild = (i: number) => {
        let arr = [...props.value];
        let parentBand = arr[i];
        let obj: IBand = {};
        let K = getMaxNameIndex(arr) + 1;

        obj.name = bandPrefix + K;
        obj.hidden = false;
        obj.allowColChooser = true;
        //obj.fixed = null;

        let insertIndex = i + 1;

        if (parentBand != null) {
            obj.band = parentBand.name;

            // const level = GridBandField.calculateLevel(props.bands, value);
            let K = -1;
            let lastSibling: IBand;

            _.each(arr, (band, k) => {
                if (band.band === parentBand.name) {
                    if (k > K) {
                        K = k;
                        lastSibling = band;
                    }
                }
            });

            if (K >= 0) {
                //insertIndex = K + 1;
                //LL: number of children
                let o = _.countBy(arr, (band) => {
                    return band.band === lastSibling.name ? 'yes' : 'no';
                });

                insertIndex = K + (o.yes == null ? 0 : o.yes) + 1;
            }
        }

        //arr.push(obj);
        arr.splice(insertIndex, 0, obj); //LL: after all siblings
        handleValueChange(arr);
    };

    const handleOnChangeRow = (band: IBand, index: number) => {
        const valueCopy = [...props.value];

        valueCopy.splice(index, 1, band)[0];
        handleValueChange(valueCopy);
    };

    const handleOnRemoveRow = (i) => {
        let arr = props.value.slice(0);
        //LL: also correct children
        let parentBand = arr[i];

        _.each(arr, (band) => {
            if (band.band === parentBand.name) {
                if (parentBand.band != null) {
                    band.band = parentBand.band;
                } else {
                    delete band.band;
                }
            }
        });

        arr.splice(i, 1);
        handleValueChange(arr);
    };

    const handleOnShowButtonClick = () => {
        setContentShown(!contentShown);
    };

    let glyph = contentShown ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down';
    let title = contentShown ? 'hide content' : 'show content';
    //LL: without "btn btn-default"  className="show-button "
    let showButtonElem = (
        <div style={{ display: 'inline-block', marginLeft: '10px', marginTop: '3px' }} title={title}>
            <span className={'glyphicon ' + glyph} onClick={handleOnShowButtonClick}></span>
        </div>
    );

    if (asTreeFlag) {
        let rows = _.map(props.value, (obj, i) => {
            return (
                <GridBandFieldTreeRow
                    key={i}
                    i={i}
                    value={obj}
                    bands={props.value}
                    onChange={handleOnChangeRow}
                    onRemove={handleOnRemoveRow}
                    onAddChild={handleOnAddChild}
                />
            );
        });

        let showTableHeaders = rows.length > 0;

        let style1 = { marginBottom: 10 }; // class "table" has margin-bottom:20px

        let style2 = {
            paddingBottom: 10
        };

        let cntElem;
        let content;

        if (contentShown) {
            // <th className="cell-allowColChooser">Allow in Column Chooser</th>
            content = (
                <table className={'table' + (props.border === true ? ' table-bordered' : '')} style={style1}>
                    {showTableHeaders === true ? (
                        <thead>
                            <tr>
                                <th className="cell-remove"></th>
                                <th className="cell-remove"></th>
                                <th className="cell-name">{'Name'}</th>
                                <th className="cell-caption">{'Caption'}</th>
                                <th className="cell-fixed">{'Fix to Side'}</th>
                                <th className="cell-hidden">{'Initially Hidden'}</th>
                            </tr>
                        </thead>
                    ) : null}
                    <tbody>
                        {rows}
                        <GridBandFieldTreeRow onChange={handleOnAddRow} />
                    </tbody>
                </table>
            );
        } else {
            cntElem = (
                <span style={{ marginLeft: '6px', color: 'rgba(51,51,51,0.6)' }}>
                    {props.value != null ? props.value.length : 0}
                </span>
            );
        }

        return (
            <div className={'grid-band-field'}>
                <div className={'div-container'} style={style2}>
                    <label>{'Bands'}</label>
                    {showButtonElem}
                    {cntElem}
                    {content}
                </div>
            </div>
        );
    } else {
        let rows = _.map(props.value, (obj, i) => {
            return (
                <GridBandFieldRow
                    key={i}
                    i={i}
                    value={obj}
                    bands={props.value}
                    onChange={handleOnChangeRow}
                    onRemove={handleOnRemoveRow}
                />
            );
        });

        let showTableHeaders = rows.length > 0;
        let style1 = { marginBottom: 10 }; // class "table" has margin-bottom:20px
        let style2 = {
            paddingBottom: 10
        };
        let cntElem;
        let content;

        if (contentShown) {
            content = (
                <table className={'table' + (props.border === true ? ' table-bordered' : '')} style={style1}>
                    {showTableHeaders === true ? (
                        <thead>
                            <tr>
                                <th className="cell-band">{'Parent Band'}</th>
                                <th className="cell-remove"></th>
                                <th className="cell-name">{'Name'}</th>
                                <th className="cell-caption">{'Caption'}</th>
                                <th className="cell-fixed">{'Fix to Side'}</th>
                                <th className="cell-hidden">{'Initially Hidden'}</th>
                                <th className="cell-allowColChooser">{'Allow in Column Chooser'}</th>
                            </tr>
                        </thead>
                    ) : null}
                    <tbody>
                        {rows}
                        <GridBandFieldRow onChange={handleOnAddRow} />
                    </tbody>
                </table>
            );
        } else {
            cntElem = (
                <span style={{ marginLeft: '6px', color: 'rgba(51,51,51,0.6)' }}>
                    {props.value != null ? props.value.length : 0}
                </span>
            );
        }

        return (
            <div className={'grid-band-field'}>
                <div className={'div-container'} style={style2}>
                    <label>{'Bands'}</label>
                    {showButtonElem}
                    {cntElem}
                    {content}
                </div>
            </div>
        );
    }
}
